import * as React from 'react';

import * as styles from './styles.css';
import { UIText1 } from '@cian/ui-kit';

export const FAQContent: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles['item']}>
      <UIText1 color="text-primary-default">{children}</UIText1>
    </div>
  );
};
